import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteNote, closeDeleteNoteModal } from 'redux/actions/notes'

const DeleteModal = ({ isOpen, closeModal, note, deleteNote, isLoading, source, history }) => !note ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Nota</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar esta nota ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteNote({note, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  note: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteNote: PropTypes.func.isRequired,
}

const mapStateToProps = ({
  notes: { openedDeleteNoteModal, selectedNote, deletingNote, source }
}) => ({
  isOpen: openedDeleteNoteModal,
  note: selectedNote,
  isLoading: deletingNote,
  source
})

const mapDispatchToProps = dispatch => ({
  deleteNote: info => dispatch(deleteNote(info)),
  closeModal: () => dispatch(closeDeleteNoteModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
